import { createSlice } from '@reduxjs/toolkit';

import store from './store';

import endPoints from '../api/endpoint';
import { getApiCall, postApiCall, putApiCall } from '../api/methods';
import { EpisodeState } from '../types';
import { setCommonDataLoader } from './commonSlice';
import { notify } from '../Utils/toastify';
import { setCrewDocCount, setOrderSetCount } from './ProductionSlice';
import { setSpendingPieChart, setSpendings } from './dashboardSlice';
import { colorsClassNames, colorsNames } from '../Utils/constantData';

const initialState: EpisodeState = {
  episodeDetails: {},
  departmentList: {},
  episodeList: {},
  episodeSchedule: {},
  episodeGraph: {},
  episodeLocations: {},
  graphLoader: false,
  episodeSetList: {},
  episodeActiveSetList: {},
  episodeInactiveSetList: {},
  episodeUpcomingetList: {},
  loading: false,
  setepisode: {},
  getrole: [],
  getrolebyid: {},
  episodedeatilbanner: {},
  episodeFormData: {},
  contacts: [],
};
interface EpisodeManagementPayload {
  loading: boolean;
  // You can add other properties here if necessary
}
const episodeSlice = createSlice({
  name: 'episode',
  initialState,
  reducers: {
    updateSetDepartmentlist: (state: any, action: any) => {
      const { payload }: any = action;
      state.departmentList = payload;
    },
    updateEpisodeList: (state: any, action: any) => {
      const { payload }: any = action;
      state.episodeList = payload;
    },
    setEpisodeDetailsbanner: (state: any, action: any) => {
      const { payload }: any = action;
      state.episodedeatilbanner = payload;
    },
    updateEpisodeSchedule: (state: any, action: any) => {
      const { payload }: any = action;
      state.episodeSchedule = payload;
    },
    setSetEpisodeGraph: (state, action) => {
      const { payload }: any = action;
      state.episodeGraph = payload;
    },
    setSpendingGraphLoader: (state, action) => {
      const { payload }: any = action;
      state.graphLoader = payload;
    },
    setEpisodeLocations: (state, action) => {
      const { payload }: any = action;
      state.episodeLocations = payload;
    },
    setEpisodeSetList: (state, action) => {
      const { payload }: any = action;
      state.episodeSetList = payload;
    },
    setEpisodeActiveSetList: (state, action) => {
      const { payload }: any = action;
      state.episodeActiveSetList = payload;
    },
    setEpisodeInactiveSetList: (state, action) => {
      const { payload }: any = action;
      state.episodeInactiveSetList = payload;
    },
    setEpisodeUpcomingSetList: (state, action) => {
      const { payload }: any = action;
      state.episodeUpcomingetList = payload;
    },
    setLoading: (state, action) => {
      const { payload }: any = action;
      state.loading = payload;
    },
    setEpisodes: (state, action) => {
      const { payload }: any = action;
      state.setepisode = payload;
    },
    updateEpisodeManagement: (
      state: any,
      action: { payload: EpisodeManagementPayload },
    ) => {
      return { ...state, ...action.payload };
    },
    getPermissionroles: (state, action) => {
      const { payload }: any = action;
      state.getrole = payload;
    },
    getPermissionRolesbyId: (state, action) => {
      const { payload }: any = action;
      state.getrolebyid = payload;
    },
    updateEpisodeDetails: (state: any, action: any) => {
      const { payload }: any = action;
      state.episodeDetails = payload;
    },
    setEpisodeFormDetails: (state, action) => {
      const { payload }: any = action;
      state.episodeFormData = payload;
    },
    setEpisodeContactsList: (state, action) => {
      const { payload }: any = action;
      state.contacts = payload;
    },
  },
});

export const {
  updateEpisodeDetails,
  updateSetDepartmentlist,
  updateEpisodeList,
  updateEpisodeSchedule,
  setSetEpisodeGraph,
  setSpendingGraphLoader,
  setEpisodeLocations,
  setEpisodeSetList,
  setLoading,
  setEpisodes,
  updateEpisodeManagement,
  getPermissionroles,
  setEpisodeDetailsbanner,
  getPermissionRolesbyId,
  setEpisodeActiveSetList,
  setEpisodeInactiveSetList,
  setEpisodeUpcomingSetList,
  setEpisodeFormDetails,
  setEpisodeContactsList,
} = episodeSlice.actions;

export const getDepartmentListOfSet = (setId: any, cb?: any) => {
  const { dispatch } = store;
  // dispatch(setLoading(true))
  const apiendpoint = `${endPoints.set.departmentList}&entityId=${setId}`;
  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(updateSetDepartmentlist(data.data));
        cb(data.data);
      }
      // dispatch(setLoading(false))
    },

    (e: any) => {
      console.log(e);
    },
  );
};

export const getEpisodeList = (cb?: any) => {
  const { dispatch } = store;
  // dispatch(setLoading(true))
  const apiendpoint = endPoints.episode.episodeDashList;
  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data) {
        dispatch(updateEpisodeList(data.data));
        cb(data.data);
      }
      // dispatch(setLoading(false))
    },

    (e: any) => {
      console.log(e);
    },
  );
};

export const getEpisodeSchedule = (cb?: any) => {
  const { dispatch } = store;
  // dispatch(setLoading(true))
  const apiendpoint = endPoints.episode.episodeScheduleStatus;
  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data) {
        dispatch(updateEpisodeSchedule(data.data));
        cb(data.data);
      }
      // dispatch(setLoading(false))
    },

    (e: any) => {
      console.log(e);
    },
  );
};

export const getEpisodeSpendingGraph = (
  type: string,
  id: string,
  range: string,
  productionId?: string,
  cb?: any,
) => {
  const { dispatch } = store;
  // dispatch(setLoading(true))
  dispatch(setSpendingGraphLoader(true));

  // console.log('Graph =>>', type, id, range)

  // Build the API endpoint with the query and studioId
  let apiendpoint = endPoints.production.spendingGraph(type, id, range);

  if (productionId) {
    apiendpoint = `${apiendpoint}&productionId=${productionId}`;
  }

  // Make the API call
  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        // Check the status value and dispatch the appropriate action
        // console.log('data', data)
        dispatch(setSetEpisodeGraph(data?.data));

        cb(data.data);
      }

      // Stop loading indicator
      // dispatch(setLoading(false))
      dispatch(setSpendingGraphLoader(false));
    },
    (e: any) => {
      // Handle error, stop loading
      // dispatch(setLoading(false))
      dispatch(setSpendingGraphLoader(false));
    },
  );
};

export const getEpisodeLocationList = (
  productionId: string,
  urlParam: any,
  cb?: any,
) => {
  const { dispatch } = store;
  // dispatch(setLoading(true))

  const apiendpoint = `${urlParam}?episodeId=${productionId}`;

  // Make the API call
  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        // Check the status value and dispatch the appropriate action
        // console.log('data', data)
        dispatch(setEpisodeLocations(data?.data));

        cb(data.data);
      }

      // Stop loading indicator
      // dispatch(setLoading(false))
    },
    (e: any) => {
      // Handle error, stop loading
      // dispatch(setLoading(false))
    },
  );
};

export const getEpisodeSetList = (
  productionId: string,
  episodeId: string,
  status?: string,
  cb?: any,
) => {
  const { dispatch } = store;
  // dispatch(setLoading(true))

  let apiendpoint = `${endPoints.production.setList}?productionId=${productionId}`;
  if (episodeId) apiendpoint += `&episodeId=${episodeId}`;

  if (status) apiendpoint += `&status=${status}`;

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        // Check the status value and dispatch the appropriate action
        // console.log('data', data)

        if (status === 'ACTIVE') {
          dispatch(setEpisodeActiveSetList(data.data));
        } else if (status === 'COMPLETED') {
          console.log('completed');
          dispatch(setEpisodeInactiveSetList(data.data));
        } else if (status === 'INACTIVE') {
          dispatch(setEpisodeUpcomingSetList(data.data));
        } else {
          dispatch(setEpisodeSetList(data?.data));
        }

        cb(data.data);
      }

      // Stop loading indicator
      // dispatch(setLoading(false))
    },
    (e: any) => {
      // Handle error, stop loading
      // dispatch(setLoading(false))
    },
  );
};

// export const addEpisodes = (values: any, callback: any) => {
//   return (dispatch: any, getState: any) => {
//     dispatch(updateEpisodeManagement({ loading: true }));

//     postApiCall(
//       endPoints.episode.createepisode,
//       values,
//       (s: any) => {
//         const {
//           data: { statusCode, message }, // Assuming the response includes a 'message'
//         } = s;

//         // Check if statusCode is 200 and handle success
//         if (statusCode && statusCode === 200) {
//           // Notify success and run callback
//           notify(message, 'success');
//           if (callback) {
//             callback(); // Execute callback if provided
//           }
//         }

//         // Stop loading after API call is complete
//         dispatch(updateEpisodeManagement({ loading: false }));
//       },
//       (e: any) => {
//         // Handle error case, stop loading
//         dispatch(updateEpisodeManagement({ loading: false }));
//         if (e?.data && e?.data.message) {
//           notify(e?.data.message, 'error');
//         } else {
//           notify('An error occurred', 'error'); // Generic error message if no specific message is returned
//         }
//       }
//     );
//   };
// };

export const addEpisodes = (values: any, type: string, cb?: any) => {
  // return (dispatch: any, getState: any) => {
  console.log('dataToSend', values);
  // dispatch(setCommonDataLoader(true))
  postApiCall(
    endPoints.episode.createEpisode,
    values,
    (s: any) => {
      const {
        data: { statusCode, message, data },
      } = s;

      console.log('RESSS', s);
      if (statusCode && statusCode === 200) {
        notify(`${type} created successfully`, 'success');
        if (cb) cb(data);
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
        if (cb) cb();
      }
    },
  );
  // }
};

export const updateeEpisode = (
  setId: string,
  values: any,
  type: string,
  cb?: any,
) => {
  // return (dispatch: any, getState: any) => {
  console.log('dataToSend', values);
  // dispatch(setCommonDataLoader(true))
  putApiCall(
    `${endPoints.episode.createepisode}/${setId}`,
    values,
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;

      console.log('RESSS', s);
      if (statusCode && statusCode === 200) {
        notify(message, 'success');
        if (cb) cb();
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
  // }
};

export const getPermissionRoles = (cb?: any) => {
  const { dispatch } = store;
  // dispatch(setLoading(true))

  const apiendpoint = endPoints.episode.getbaserole;

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        // Check the status value and dispatch the appropriate action
        // console.log('data', data)
        dispatch(getPermissionroles(data?.data));

        cb(data.data);
      }

      // Stop loading indicator
      // dispatch(setLoading(false))
    },
    (e: any) => {
      // Handle error, stop loading
      // dispatch(setLoading(false))
    },
  );
};

export const getPermissionRolesbyIdS = (staticRoleId: string, cb?: any) => {
  const { dispatch } = store;
  // dispatch(setLoading(true))

  const apiendpoint = `${endPoints.episode.getbaseroles}/${staticRoleId}`;

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        // Check the status value and dispatch the appropriate action
        console.log('data APIIII=>>>>', data);
        dispatch(getPermissionRolesbyId(data?.data));

        cb(data.data);
      }

      // Stop loading indicator
      // dispatch(setLoading(false))
    },
    (e: any) => {
      // Handle error, stop loading
      // dispatch(setLoading(false))
    },
  );
};

export const getEpisodeDetails = (episodeId: any, cb?: any) => {
  const { dispatch } = store;

  dispatch(setLoading(true)); // Show loader before the API call

  getApiCall(
    `${endPoints.episode.episodeDetails}/${episodeId}`,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(updateEpisodeDetails(data.data));

        if (cb) cb(data.data);
      }
      dispatch(setLoading(false)); // Hide loader after successful response
    },
    (e: any) => {
      // Handle error if necessary (you can log it or display a toast, etc.)
      console.error('Error fetching production details:', e);
      dispatch(setLoading(false)); // Hide loader after error
    },
  );
};

export const getEpisodeDetailsbanner = (episodeId: any, cb?: any) => {
  const { dispatch } = store;
  dispatch(setLoading(true));

  const apiendpoint = endPoints.episodeDetailsBanner + episodeId;

  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(updateEpisodeDetails(data?.data));
        cb(data.data);
      }
      dispatch(setLoading(false));
    },
    (e: any) => {
      dispatch(setLoading(false));
    },
  );
};

// ---------------------- API Call Parrallel  -- - -- -- -- -- ----- -- - - ---

export const getCrewDocumentCountPromise = (
  entityType: any,
  entityId: any,
  modelEntityId?: any,
  modelEntityType?: any,
): Promise<any> => {
  return new Promise((resolve, reject) => {
    const { dispatch } = store;
    let apiendpoint = `${endPoints.production.crewdoccount}?entityId=${entityId}&entityType=${entityType}`;

    if (modelEntityId && modelEntityType) {
      apiendpoint += `&modelEntityId=${modelEntityId}&modelEntityType=${modelEntityType}`;
    }

    getApiCall(
      apiendpoint,
      (s: any) => {
        const { data } = s;
        if (data?.data) {
          dispatch(setCrewDocCount(data.data));
          resolve(data.data);
        } else {
          resolve(null);
        }
      },
      (e: any) => reject(e),
    );
  });
};

export const getSetOrderCountPromise = (
  entityId: any,
  type?: string,
): Promise<any> => {
  return new Promise((resolve, reject) => {
    const { dispatch } = store;
    let apiendpoint = endPoints.production.setordercount;

    if (type === 'episode') {
      apiendpoint += `?episodeId=${entityId}`;
    } else if (type === 'location') {
      apiendpoint += `?locationId=${entityId}`;
    } else if (type === 'set') {
      apiendpoint += `?setId=${entityId}`;
    } else {
      apiendpoint += `?productionId=${entityId}`;
    }

    getApiCall(
      apiendpoint,
      (s: any) => {
        const { data } = s;
        if (data?.data) {
          dispatch(setOrderSetCount(data.data));
          resolve(data.data);
        } else {
          resolve(null);
        }
      },
      (e: any) => reject(e),
    );
  });
};

export const getSpendingsPromise = (type?: any, id?: string): Promise<any> => {
  return new Promise((resolve, reject) => {
    const { dispatch } = store;
    dispatch(setCommonDataLoader(true));

    let endPoint = endPoints.dashBoard.spendings;
    endPoint += `?entityType=${type}&entityId=${id}`;

    getApiCall(
      endPoint,
      (s: any) => {
        const { data } = s;
        if (data?.data) {
          dispatch(setSpendings(data.data));
          resolve(data.data);
        } else {
          resolve(null);
        }
        dispatch(setCommonDataLoader(false));
      },
      (e: any) => {
        dispatch(setCommonDataLoader(false));
        notify(e?.data?.message, 'error');
        reject(e);
      },
    );
  });
};

export const getLocationAndEpisodeSetPieChartSpendingsPromise = (
  id: any,
  type: string,
  productionId?: any,
): Promise<any> => {
  return new Promise((resolve, reject) => {
    const { dispatch } = store;
    dispatch(setCommonDataLoader(true));

    let endPoint = endPoints.production.locationAndEpisodePiaChartData;
    if (type === 'location') {
      endPoint += `?locationId=${id}`;
    } else if (type === 'episode') {
      endPoint = `${endPoints.production.spendingPiaChartData}?episodeId=${id}&productionId=${productionId}&filterType=production_schedule`;
    }

    getApiCall(
      endPoint,
      (s: any) => {
        const { data } = s;
        if (data?.data) {
          const formatted = [
            ...data.data.topFiveSpendings,
            ...data.data.others,
          ]?.map((item: any, i: number) => ({
            ...item,
            className: colorsClassNames[i],
            color: colorsNames[i],
          }));
          dispatch(setSpendingPieChart(formatted));

          resolve(formatted);
        } else {
          resolve([]);
        }
        dispatch(setCommonDataLoader(false));
      },
      (e: any) => {
        dispatch(setCommonDataLoader(false));
        notify(e?.data?.message, 'error');
        reject(e);
      },
    );
  });
};

export const getEpisodeDetailsbannerPromise = (
  episodeId: any,
): Promise<any> => {
  return new Promise((resolve, reject) => {
    const { dispatch } = store;
    dispatch(setLoading(true));

    const apiendpoint = endPoints.episodeDetailsBanner + episodeId;

    getApiCall(
      apiendpoint,
      (s: any) => {
        const { data } = s;
        if (data?.data) {
          dispatch(updateEpisodeDetails(data?.data));
          resolve(data.data);
        } else {
          resolve(null);
        }
        dispatch(setLoading(false));
      },
      (e: any) => {
        dispatch(setLoading(false));
        reject(e);
      },
    );
  });
};

export const updateEpisodeFormDetails = (data: any, cb?: any) => {
  const { dispatch } = store;

  const contacts = store.getState().episode.contacts;

  dispatch(setEpisodeFormDetails(data));
  if (cb) cb(data);
};

export const updateContactsList = (data: any) => {
  const { dispatch } = store;

  const contacts = store.getState().episode.contacts;

  dispatch(setEpisodeContactsList([...contacts, data]));
};

export const removeContactsList = (data: any) => {
  const { dispatch } = store;

  dispatch(setEpisodeContactsList(data));
};

export default episodeSlice.reducer;
